import { render, staticRenderFns } from "./SortHandler.vue?vue&type=template&id=1ad9faa0&scoped=true&"
var script = {}
import style0 from "./SortHandler.vue?vue&type=style&index=0&id=1ad9faa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad9faa0",
  null
  
)

export default component.exports